import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormField } from './form-field';
export const FieldGroup = ({ label, children, className = '', groupClassName = '', tooltip, }) => {
    const id = label ? label.split(' ').join('-') : '';
    return (_jsx("div", { className: `relative mt-5 flex w-full flex-col rounded-md border border-solid border-gray-300 p-2 ${className}`, children: _jsx(FormField, { label: label, htmlFor: id, labelVariant: 'label', tooltip: tooltip, labelClassName: 'absolute -top-4 bg-white p-1.5', containerClassName: 'w-full', children: _jsx("div", { id: id, className: `flex flex-wrap w-full gap-4 ${groupClassName}`, children: children }) }) }));
};
export default FieldGroup;
